import { gql } from "@/gql/__generated__";
import { PublicAppsQuery } from "@/gql/__generated__/graphql";
import { useQuery } from "@apollo/client";
import { PublicApp } from "../../features/organization-apps/types/app.type";

const PUBLIC_APPS = gql(`
  query publicApps {
    publicTools {
      __typename
      id
      name
      description
      pictureUrl
      publicUrl
      createdAt
      developer {
        __typename
        fullName
      }
    }
  }
`);

export function usePublicApps() {
  const { data, ...res } = useQuery(PUBLIC_APPS);

  const publicApps = convertPublicToolsToApps(data?.publicTools);

  return { data: publicApps, ...res };
}

function convertPublicToolsToApps(
  publicTools: PublicAppsQuery["publicTools"]
): PublicApp[] {
  if (!publicTools) return [];
  const apps: PublicApp[] = publicTools.map(
    ({
      id,
      name,
      description,
      developer,
      pictureUrl,
      publicUrl,
      createdAt
    }) => ({
      __typename: "App",
      id,
      displayName: name,
      description: description || "",
      createdBy: developer,
      pictureUrl,
      origin: "public",
      publicUrl,
      createdAt
    })
  );

  return apps;
}
